// FUNC-105 — Promo campaña octubre 2026: sesión individual estándar (45 min)
// ONLINE a $25.000 si la sesión cae en octubre (fecha local Santiago).
//
// Espejo exacto de la regla server-side en `create_consultation` (rama pública)
// y `create_consultation_investor` — ver
// sql/migrations/func105_promo_online_octubre_2026_09_29.sql. Si se toca uno,
// se toca el otro (docs/PRECIOS.md).
//
// Reemplaza SOLO el precio de lista: la tarifa diferenciada del paciente sigue
// mandando por encima (decisión del usuario 2026-09-29), así que los callers
// aplican esto al precio de lista, nunca a una tarifa diferenciada.
// Se apaga sola: sesiones desde el 2026-11-01 vuelven al precio de lista.

export const PROMO_ONLINE = {
  precio: 25000,
  desde: '2026-10-01', // inclusive, YYYY-MM-DD local Santiago
  hasta: '2026-10-31', // inclusive
} as const;

interface PromoInput {
  tipo: string;        // 'individual' | 'pareja' | 'familia' | 'familiar'
  duracion: number;
  modalidad: string;   // 'presencial' | 'online' | 'domicilio' | ...
  fecha?: string | null; // YYYY-MM-DD de la sesión; sin fecha no aplica
}

export function aplicaPromoOnline({ tipo, duracion, modalidad, fecha }: PromoInput): boolean {
  if (!fecha) return false;
  const dia = fecha.slice(0, 10);
  return tipo === 'individual'
    && duracion === 45
    && modalidad === 'online'
    && dia >= PROMO_ONLINE.desde
    && dia <= PROMO_ONLINE.hasta;
}

export function precioListaConPromo(precioLista: number, input: PromoInput): number {
  return aplicaPromoOnline(input) ? PROMO_ONLINE.precio : precioLista;
}

// Para avisos antes de elegir fecha (ej. selector de modalidad): ¿la promo
// sigue vigente para alguna fecha agendable desde hoy?
export function promoOnlineVigente(hoy: Date = new Date()): boolean {
  const hoyStr = hoy.toLocaleDateString('en-CA', { timeZone: 'America/Santiago' });
  return hoyStr <= PROMO_ONLINE.hasta;
}
